import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { 
  tryToFetchMyPendingInvites,
  tryToJoinEnterprise
} from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'

class UserSettingsPendingInvites extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {

    }
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetch){
      dispatch(tryToFetchMyPendingInvites());
    }
  }

  render(){
    const { dispatch, user, team } = this.props; 
    const state = this.state;

    if(user.tryingToFetchMyPendingInvites) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    if(!user.email_verified){
      return <p>
        <Link to="/settings/my-account/email/verify">Verify your email address</Link> in order to receive invitations to firms and enterprises.
      </p>
    }

    let invites = user.pendingInvites.filter(p => p.type !== 'enterprise');

    if(invites.length === 0){
      return <p>
        You have no pending invitations.
      </p>
    }

    return <div>
      <ul className="list-divided">
        {
          invites.map((p, i)=>{

            return <li key={i}>
              <small className="semi-translucent">{moment(p.created_on).fromNow()}</small>
              
              <div>
                <p className="lead">💌 You've been invited to join the <span className="text-900">{p.display_name}</span> firm.</p>
                <p>
                  Joining this firm will grant you access and the ability to contribute to it's saved patterns.<br/>
                  You can join multiple firms, your existing patterns will remain yours, and you can leave anytime.
                </p>
              </div>
            
              
              <div className="flex-split">
                <Link to={'/accept-invitation/' + p.invite_code} className="button-link">
                  <Button
                    display="Accept Invitation"
                    color="success"
                    />
                </Link>
              </div>
            </li>
          })
        }
      </ul>
    </div>
  }
}
const mapStateToProps = (state) => {
  const { user, team } = state;

  return {
    user, team
  }
}

export default connect(mapStateToProps)(UserSettingsPendingInvites);



// WEBPACK FOOTER //
// ./src/components/UserSettingsPendingInvites/UserSettingsPendingInvites.js